export class ToolStorage {
    public key: string;
    public liftNumber: string;
    public liftShelf: number;
    public shelfPosition: string;
    public cart: number;


    constructor(toolLocation: any = {}) {
        this.key = toolLocation.key;
        this.liftNumber = toolLocation.liftNumber || 0;
        this.liftShelf = toolLocation.liftShelf || 0;
        this.shelfPosition = toolLocation.shelfPosition || '';
        this.cart = toolLocation.cart || 0;
    }

    get type() {
        return "tool-location";
    }
}
